export default __webpack_public_path__ + "static/img-4-d4cb9f7cefff678ee03a889f208f5edd.jpg";